// extracted by mini-css-extract-plugin
module.exports = {"container":"ProfileHome_container__1AvvN","form-container":"ProfileHome_form-container__1_FV6","data_container":"ProfileHome_data_container__1Oekl"};